import io from 'socket.io-client';

export const ConnectSocket = (storeId) => {
  // check staging or production, by default is API URL with default path
  const apiUrl = new URL(process.env.REACT_APP_API_URL);
  const path =
    apiUrl.pathname[apiUrl.pathname.length - 1] === '/'
      ? 'socket.io'
      : '/socket.io';
  return io(apiUrl.origin, {
    path: apiUrl.pathname + path,
    query: `storeId=${storeId}`,
    extraHeaders: {
      'Access-Control-Allow-Origin': '*',
    },
  });
};
